import { DeliveryCheckManagerBase } from '@euler/app/flows/task/functions/task-detail/delivery-check/DeliveryCheckManagerBase';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { TaskTimeoutInfo } from '@euler/app/flows/task/types';
import { DeliveryCheckSceneType } from '@euler/model/enum';
import { DeliveryCheckBase } from '@euler/model/task-detail';
import { createContext, memo, ReactNode, useContext } from 'react';

export type DeliveryCheckContextProps = {
  manager: DeliveryCheckManagerBase<DeliveryCheckBase>;
  timeoutInfo?: TaskTimeoutInfo;
};

export const DeliveryCheckContext = createContext<DeliveryCheckContextProps>(
  null as any,
);

export const useDeliveryCheckContext = () => useContext(DeliveryCheckContext);

export const DeliveryCheckContextProvider = memo(
  ({
    sceneType,
    timeoutInfo,
    children,
  }: {
    sceneType: DeliveryCheckSceneType;
    timeoutInfo?: TaskTimeoutInfo;
    children?: ReactNode;
  }) => {
    const {
      taskManager: { deliveryCheckManager, samplingCheckManager },
    } = useTaskContext();

    return (
      <DeliveryCheckContext.Provider
        value={{
          timeoutInfo,
          manager:
            sceneType === DeliveryCheckSceneType.CompletionCheck
              ? deliveryCheckManager
              : samplingCheckManager,
        }}
      >
        {children}
      </DeliveryCheckContext.Provider>
    );
  },
);
